// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const SignalRankSchema = z.enum(['UNRANKED','APPROVED','REJECTED'] as const);

export type SignalRankType = `${z.infer<typeof SignalRankSchema>}`

export default SignalRankSchema;
